import "./../Style.css";
import { isMobile } from "react-device-detect";
import { useEffect } from "react";
import { ContactDesktop } from "./ContactDesktop";
import { ContactMobile } from "./ContactMobile";

export const Contact = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const MobileView = () => {
    return (
      <>
        <ContactMobile />
      </>
    );
  };

  const DesktopView = () => {
    return (
      <>
        <ContactDesktop />
      </>
    );
  };
  return <div>{isMobile ? <MobileView /> : <DesktopView />}</div>;
};
